<script lang="ts">
	// import { afterNavigate, beforeNavigate } from '$app/navigation'
	import { page } from '$app/state'
	import Field from '#components/field.svelte'

	interface Props {
		filters:
			| Array<{
					label: string
					href: string
					active: boolean
			  }>
			| false
		categories?: Record<string, string> | false
		dates?: Record<string, string> | false
		events?: boolean
		// form_state?: 'idle' | 'loading'
		event_view?: 'grid' | 'calendar'
	}

	let {
		filters,
		categories,
		dates,
		events,
		// form_state = $bindable('idle'),
		event_view = $bindable('grid')
	}: Props = $props()

	let form: HTMLFormElement
	let search = $derived(page.url.searchParams.get('search') || '')

	// beforeNavigate(event => {
	// 	const from_page = event.from?.params?.page
	// 	const from_route = event.from?.route?.id
	// 	const to_page = event.to?.params?.page
	// 	const to_route = event.to?.route?.id

	// 	if (from_page !== to_page || from_route !== to_route) return

	// 	form_state = 'loading'
	// })
	// afterNavigate(() => (form_state = 'idle'))

	const type = $derived(page.url.searchParams.get('type') || '')
</script>

<form class="filterbar contain" class:no-filters={!filters} bind:this={form} data-sveltekit-reset="false">
	{#if type}
		<input type="hidden" name="type" value={type} />
	{/if}
	{#if events}
		<div class="views">
			<button class="view" class:active={event_view === 'grid'} onclick={() => (event_view = 'grid')}>
				<svg class="svg">
					<use xlink:href="/images/vector.svg#grid"></use>
				</svg>
				Grid
			</button>
			<button class="view" class:active={event_view === 'calendar'} onclick={() => (event_view = 'calendar')}>
				<svg class="svg">
					<use xlink:href="/images/vector.svg#calendar"></use>
				</svg>
				Calendar
			</button>
		</div>
	{/if}
	{#if filters}
		<div class="filters" class:events>
			{#each filters as filter (filter.label)}
				<a class="filter" class:active={filter.active} href={filter.href} data-sveltekit-reset="false">
					{filter.label}
				</a>
			{/each}
		</div>
	{/if}
	<div class="search" class:events>
		<Field name="search" id="search" icon="search" placeholder="Search" invisible bind:value={search} />
	</div>
	{#if !events}
		<div class="dropdowns">
			{#if categories}
				<Field
					name="category"
					id="category"
					icon="setting"
					options={categories}
					inline
					onchange={() => form?.requestSubmit()}
					value={page.url.searchParams.get('category') || ''}
				/>
			{/if}
			{#if dates}
				<Field
					name="year"
					id="year"
					icon="calendar"
					options={dates}
					inline
					onchange={() => form?.requestSubmit()}
					value={page.url.searchParams.get('year') || ''}
				/>
			{/if}
		</div>
	{/if}
</form>

<style lang="css">
	.filterbar {
		display: grid;
		gap: 1rem;
		padding-block: 1.5rem;

		@media (--from-mobile) {
			gap: 2rem;
			grid-template-columns: repeat(6, 1fr);
			padding-block-start: 2rem;
		}
	}

	.views {
		display: flex;
		gap: 1.5rem;

		@media (--from-mobile) {
			grid-column: span 5;
		}
	}

	.view {
		align-items: center;
		color: var(--c-midground);
		display: flex;
		gap: 0.625rem;
		font: 500 var(--f-body1);
		letter-spacing: var(--ls-body1);

		&.active {
			color: var(--c-foreground);
		}

		& + .view::before {
			background-color: var(--c-midground);
			content: '';
			display: block;
			margin-inline-end: 1rem;
			size: 1.75rem 0.125rem;
		}
	}

	.svg {
		size: 1.75rem;
	}

	.filters {
		align-items: center;
		display: flex;
		gap: 3rem;
		overflow-x: auto;

		&::-webkit-scrollbar {
			display: none;
		}

		@media (--from-mobile) {
			grid-column: span 5;
		}

		&.events {
			order: 1;
			grid-column: 1 / -1;
			margin-block-end: 2rem;
		}
	}

	.filter {
		color: var(--c-charcoal);
		font: 600 var(--f-h5);
		letter-spacing: var(--ls-h5);
		white-space: nowrap;

		&.active {
			color: var(--c-foreground);
			text-decoration: underline;
		}
	}

	.search {
		display: flex;

		.no-filters & {
			order: 1;
			@media (--from-mobile) {
				grid-column: 6;
			}
		}

		@media (--from-mobile) {
			justify-content: flex-end;
		}

		:global {
			.field {
				transition: width 0.2s ease;
				width: 7.5rem;

				&:focus-within,
				&:not(:has(input:placeholder-shown)) {
					width: 100%;
				}
			}
		}
	}

	.dropdowns {
		display: grid;
		gap: 1rem;
		grid-column: span 3;

		@media (--from-mobile) {
			grid-template-columns: repeat(2, minmax(0, 1fr));
		}
	}
</style>
